import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { EnquiryListComponent } from './components/enquiry-list/enquiry-list.component';
import { EnquiryDetailComponent } from './components/enquiry-detail/enquiry-detail.component';
import { NewEnquiryComponent } from './components/new-enquiry/new-enquiry.component';
import { NewEnquiryBulkComponent } from './components/new-enquiry-bulk/new-enquiry-bulk.component';
import { HomeComponent } from './components/home/home.component';
import { ProfileComponent } from './components/profile/profile/profile.component';
import { ChangePasswordComponent } from './components/profile/change-password/change-password.component';
import { AuthGuard } from './guards/auth.guard';
import { VerifyAccessComponent } from './components/verify-access/verify-access.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { SavedAddressesComponent } from './components/profile/saved-addresses/saved-addresses.component';
import { NewAddressComponent } from './components/profile/saved-addresses/new-address/new-address.component';
import { ApplicationFormComponent } from './components/application-form/application-form.component';
import { EnrolmentFormComponent } from './components/enrolment-form/enrolment-form.component';
import { RequestFormComponent } from './components/request-form/request-form.component';
import { TermsComponent } from './components/terms/terms.component';
import { SecureGuard } from './guards/secure.guard';
import { WhatsAppConsentComponent } from './components/whatsapp-consent/whatsapp-consent.component';
import { SimpleEnquiryComponent } from './components/simple-enquiry/simple-enquiry.component';
import { SimpleEnquiryDetailComponent } from './components/simple-enquiry-detail/simple-enquiry-detail.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'whatsapp-consent', component: WhatsAppConsentComponent },
  {
    path: 'verify-access',
    component: VerifyAccessComponent,
  },
  {
    path: 'no-access',
    component: AccessDeniedComponent,
  },
  {
    path: 'membership-form',
    component: ApplicationFormComponent,
  },
  {
    path: 'application-form',
    component: RequestFormComponent,
  },
  {
    path: 'enrolment-form',
    component: EnrolmentFormComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard, SecureGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      { path: 'new-enquiry', component: NewEnquiryComponent },
      { path: 'simple-enquiry', component: SimpleEnquiryComponent },
      { path: 'simple-enquiry-detail', component: SimpleEnquiryDetailComponent },
      { path: 'new-enquiry-bulk', component: NewEnquiryBulkComponent },
      { path: 'enquiry-detail/:id', component: EnquiryDetailComponent },

      // 👇 Add this block
      {
        path: 'profile',
        children: [
          { path: '', component: ProfileComponent },
          { path: 'change-password', component: ChangePasswordComponent },
          { path: 'saved-addresses', component: SavedAddressesComponent },
          { path: 'new-address', component: NewAddressComponent },
          { path: 'new-address/:id', component: NewAddressComponent },
        ],
      },
    ],
  },
  {
    path: 'terms',
    component: TermsComponent,
    canActivate: [AuthGuard]
  },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: '/dashboard' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
